import { ContactMethod, DifferentialRuleType } from './invoices.dto';

// ── Differential Updates ─────────────────────────────────────────────

export interface UpdateDifferentialDto {
  differentialRate: number; // required, min: 0, max: 100
  ruleType: DifferentialRuleType; // required
  description?: string; // optional, maxLength: 200
  effectiveDate?: string; // optional, DateOnly ISO string
  expirationDate?: string; // optional, DateOnly ISO string
}

// ── Overdue Notifications ────────────────────────────────────────────

export interface SendOverdueNotificationDto {
  invoiceIds: string[]; // required, GUID[]
  customMessage?: string; // optional, maxLength: 500
  contactMethods: ContactMethod[]; // required
}

// ── Simple Response Types ────────────────────────────────────────────

export interface SuccessMessage {
  message: string;
}
